
export interface BuyMusicChannelDto
{
    getServiceId() : string;
    getAPartyMsisdn() : string;
    getToneId() : number;
    getChannelId() : number;
    getLanguage() : string;
    getPriority() : string;
    getPaymentMode() : string;
    
}
export class BuyMusicChannelDtoImpl implements BuyMusicChannelDto
{
    private serviceId: string;
    private aPartyMsisdn: string;
    private toneId: number;
    private channelId: number;
    private language: string;
    private priority: string;
    private paymentMode: string;

    getServiceId(): string
    {
        return this.serviceId;
    }

    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }

    getAPartyMsisdn(): string
    {
        return this.aPartyMsisdn;
    }
    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }

    setToneId(toneId: number)
    {
        this.toneId = toneId;
    }
    getToneId(): number 
    {
        return this.toneId;
    }

    setChannelId(channelId: number)
    {
        this.channelId = channelId;
    }
    getChannelId(): number 
    {
        return this.channelId;
    }  
    
    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }

    setPriority(priority: string)
    {
        this.priority = priority;
    }
    getPriority(): string 
    {
        return this.priority;
    }

    setPaymentMode(paymentMode: string)
    {
        this.paymentMode = paymentMode;
    }
    getPaymentMode(): string 
    {
        return this.paymentMode;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/buymusicchannel/buymusicchanneldto.ts